// smoothScroller
// jQuery(function(){
// 	jQuery("a[href^=#]").click(function() {
// 		var speed = 1500;
// 		var href= jQuery(this).attr("href");
// 		var target = jQuery(href == "#" || href == "" ? 'html' : href);
// 		var position = target.offset().top;
// 		jQuery('body,html').animate({scrollTop:position}, speed, 'swing');
// 		return false;
// 	});
// });

// //dropdoun
// jQuery(function(){
//     jQuery("ul.gnav li").hover(function(){
//         jQuery(this).addClass("current");
//         jQuery('ul:first',this).css('visibility', 'visible');
//     }, function(){
//         jQuery(this).removeClass("current");
//         jQuery('ul:first',this).css('visibility', 'hidden');
//     });
// });

//bnr_include
// jQuery(function(){
//   if(jQuery('#js-bnr_inc').length) {
//     $.get("/user_data/2015renew/inc/bnr_inc.html",
//     function(data) {
//       jQuery("#js-bnr_inc").append(data);
//     });
//   }
// });

//bnr_include_twins
// jQuery(function(){
//   if(jQuery('#bnr-inc-twins').length) {
//     $.get("/user_data/2015renew/inc/bnr_inc_twins.html",
//     function(data) {
//       jQuery("#bnr-inc-twins").prepend(data);
//     });
//   }
// });

//pcruck
jQuery(function(){
  if(jQuery('.js-pcrucksackDetail').length) {
    var ww = jQuery(window).width();
    var wh = jQuery(window).height();
    var scrollVal;
    jQuery(window).scroll(function() {
      jQuery('.js-pcrucksackDetail').each(function() {
        //var i = jQuery(this).index();
        var pos = jQuery(this).offset().top;
        var th = jQuery(this).height();
        var fh = jQuery(this).find('.js-pcrucksackDetailFix').height();
        scrollVal = jQuery(window).scrollTop();
        if(pos < scrollVal) {
          jQuery(this).find('.js-pcrucksackDetailFix').addClass('is-fixed');
          jQuery(this).find('.js-pcrucksackDetailFix').removeClass('is-bottom');
        }
        if( pos + th - fh < scrollVal ) {
          jQuery(this).find('.js-pcrucksackDetailFix').removeClass('is-fixed');
          jQuery(this).find('.js-pcrucksackDetailFix').addClass('is-bottom');
        }
        if( pos > scrollVal ) {
          jQuery(this).find('.js-pcrucksackDetailFix').removeClass('is-fixed');
          jQuery(this).find('.js-pcrucksackDetailFix').removeClass('is-bottom');
        }
      });
    });
  }
});

//minimalwalleft
jQuery(function(){
  if(jQuery('.js-minimalwalletDetail').length) {
    var ww = jQuery(window).width();
    var wh = jQuery(window).height();
    var scrollVal;
    jQuery(window).scroll(function() {
      jQuery('.js-minimalwalletDetail').each(function() {
        //var i = jQuery(this).index();
        var pos = jQuery(this).offset().top;
        var th = jQuery(this).height();
        var fh = jQuery(this).find('.js-minimalwalletDetailFix').height();
        scrollVal = jQuery(window).scrollTop();
        if(pos < scrollVal) {
          jQuery(this).find('.js-minimalwalletDetailFix').addClass('is-fixed');
          jQuery(this).find('.js-minimalwalletDetailFix').removeClass('is-bottom');
        }
        if( pos + th - fh < scrollVal ) {
          jQuery(this).find('.js-minimalwalletDetailFix').removeClass('is-fixed');
          jQuery(this).find('.js-minimalwalletDetailFix').addClass('is-bottom');
        }
        if( pos > scrollVal ) {
          jQuery(this).find('.js-minimalwalletDetailFix').removeClass('is-fixed');
          jQuery(this).find('.js-minimalwalletDetailFix').removeClass('is-bottom');
        }
      });
    });
  }
});